<template>
    <div>
        <!-- filters -->
        <div>
            <heading-section :loading="isFetchingProducts"
                             class="d-flex">
                {{ $vuetify.lang.t('$vuetify.title.shop') }}
            </heading-section>
            <v-row id="news-filter"
                   class="px-7 pl-lg-0 mt-3 mb-3"
                   dense
                   align="center"
                   no-gutters>
                <v-col cols="auto"
                       class="flex-shrink-0 py-0">
                    <v-icon class="text-shadow--default"
                            v-if="!isFetchingProducts">mdi-filter-outline
                    </v-icon>
                    <v-skeleton-loader type="avatar"
                                       v-else />
                </v-col>
                <v-col cols="auto"
                       class="pl-4">
                    <item-filter type="chip"
                                 @input="onChangeFilter('filterShopNew', $event)"
                                 :items="[{id: 'new', name: $vuetify.lang.t('$vuetify.shop.new_in_shop')}]"
                                 item-text="name"
                                 item-value="id"
                                 :item-reset-text="itemsResetText"
                                 :value="filterShopNew"
                                 v-if="!isFetchingProducts"></item-filter>
                    <template v-else>
                        <v-skeleton-loader type="chip@3"
                                           class="d-flex" />
                    </template>
                </v-col>
            </v-row>
        </div>
        <!-- /filters -->
        <v-row>
            <!-- filters & all products -->
            <v-col cols="12"
                   class="py-0">
                <!-- filters -->
                <div class="mb-4">
                    <v-row dense
                           no-gutters
                           id="shop-filter"
                           class="align-center flex-nowrap justify-center">

                        <template v-if="!isFetchingProducts">
                            <v-col class="pl-7 pl-lg-0 pr-1">
                                <div id="shop-filter-category">
                                    <item-filter type="select"
                                                 @input="onChangeFilter('filterShopCategory', $event)"
                                                 :items="[{ id: null, title: $vuetify.lang.t('$vuetify.form_items.all_products') }, ...categories]"
                                                 item-text="title"
                                                 item-value="id"

                                                 :value="filterShopCategory"></item-filter>
                                </div>
                            </v-col>

                            <v-col class="pr-7 pr-lg-0 pl-1">
                                <item-filter type="select"
                                             @input="onChangeFilter('filterShopPoint', $event)"
                                             :items="pointRanges"
                                             item-text="name"
                                             item-value="value"
                                             id="shop-filter-points"
                                             :value="filterShopPoint"></item-filter>
                            </v-col>

                            <!-- <v-col cols="11" offset="1">
                                <h4 class="mb-2">{{ $vuetify.lang.t('$vuetify.form_items.rank_filter') }}:</h4>
                                <item-filter type="chip"
                                 @input="onChangeFilter('filterShopRank', $event)"
                                :items="ranks"
                                item-text="icon"
                                item-value="id"
                                :value="filterShopRank"></item-filter>
                            </v-col> -->
                        </template>

                        <!-- skeleton loading -->
                        <template v-else>
                            <v-col cols="2"
                                   class="flex-shrink-0 py-0">
                                <v-skeleton-loader type="avatar" />
                            </v-col>
                            <v-col cols="10">
                                <v-skeleton-loader type="chip@3"
                                                   tile
                                                   class="d-flex" />
                            </v-col>
                        </template>
                        <!-- /skeleton loading -->

                    </v-row>
                </div>
                <!-- /filters -->

                <!-- products -->
                <template v-if="productsLength > 0">
                    <template v-if="filterShopCategory === null && filterShopPoint !== null">
                        <v-row no-gutters
                               class="mx-n1">
                            <v-col v-for="product in filteredProducts"
                                   :key="product.id"
                                   class="px-1 mb-2"
                                   cols="6"
                                   sm="3">
                                <template v-if="!isFetchingProducts">
                                    <product-card :product="product"></product-card>
                                </template>

                                <!-- skeleton loading -->
                                <v-card flat
                                        tile
                                        class="pa-2 fill-height d-flex flex-column"
                                        v-else>
                                    <v-skeleton-loader type="image"
                                                       class="mb-5"
                                                       tile />
                                    <v-skeleton-loader type="heading"
                                                       class="mb-2" />
                                    <v-skeleton-loader type="sentences" />
                                </v-card>
                                <!-- /skeleton loading -->

                            </v-col>
                        </v-row>
                    </template>
                    <template v-else>
                        <v-row no-gutters
                               class="mx-n1"
                               :key="category.id"
                               v-for="category in filteredCategories"
                               v-if="productsByCategory(category).length > 0">
                            <v-col v-if="filterShopPoint === null  || filterShopPoint !== null && filterShopCategory !== null"
                                   class="px-1 mb-2"
                                   cols="12">
                                <product-card :product="category"
                                              category></product-card>
                            </v-col>
                            <v-col v-for="product in productsByCategory(category)"
                                   :key="product.id"
                                   class="px-1 mb-2"
                                   cols="6"
                                   sm="3">
                                <template v-if="!isFetchingProducts">
                                    <product-card :product="product"></product-card>
                                </template>

                                <!-- skeleton loading -->
                                <v-card flat
                                        tile
                                        class="pa-2 fill-height d-flex flex-column"
                                        v-else>
                                    <v-skeleton-loader type="image"
                                                       class="mb-5"
                                                       tile />
                                    <v-skeleton-loader type="heading"
                                                       class="mb-2" />
                                    <v-skeleton-loader type="sentences" />
                                </v-card>
                                <!-- /skeleton loading -->

                            </v-col>
                        </v-row>
                    </template>
                </template>
                <template v-else>
                    <info-card desc="$vuetify.shop.filter-no-results"></info-card>
                </template>
                <!-- /products -->
            </v-col>
            <!-- /filters & all products -->
        </v-row>
    </div>
</template>

<script>
// 3rd
import {
    mapActions,
    mapState,
} from 'vuex';
// utils
import {setPageTitle} from '../utils/helper';
// models
import Product from '../models/Product';
import ProductCategory from '../models/ProductCategory';
import Rank from '../models/Rank';
// components
import InfoCard from '../components/Cards/Info';
import ItemFilter from '../components/ItemFilter';
import ProductCard from '../components/Cards/Product';
import HeadingSection from '../components/HeadingSection';
// utils
import {LOADER_FETCH_PRODUCTS} from '../utils/constants';

export default {
    name: 'shop',
    components: {
        InfoCard,
        ItemFilter,
        ProductCard,
        HeadingSection,
    },
    data() {
        return {
            categoryFilter: null,
            pointsFilter: null,
            rankFilter: [],
        };
    },
    computed: {
        ...mapState([
            'filterShopCategory',
            'filterShopPoint',
            'filterShopRank',
            'filterShopNew',
            'tours',
            'tourShop',
        ]),
        itemsResetText() {
            return this.$vuetify.lang.t('$vuetify.form_items.all_brands');
        },
        isFetchingProducts() {
            return this.$wait.is(LOADER_FETCH_PRODUCTS);
        },
        categories() {
                // return ProductCategory.query().orderBy('title').get();
            let categories = ProductCategory.all();

            return categories.slice().sort((a, b) => {
                    return a.title.localeCompare(b.title, undefined, { sensitivity: 'base' });
            })
        },
        pointRanges() {
            return [
                {
                    name: this.$vuetify.lang.t('$vuetify.form_items.points_no_filter'),
                    value: null,
                },
                {
                    name: this.$vuetify.lang.t('$vuetify.form_items.points_0'),
                    value: 0,
                },
                {
                    name: this.$vuetify.lang.t('$vuetify.form_items.points_1'),
                    value: 1,
                },
                {
                    name: this.$vuetify.lang.t('$vuetify.form_items.points_2'),
                    value: 2,
                },
            ];
        },
        ranks() {
            return Rank.all();
        },
        products() {
            return Product.getAll();
        },
        filteredCategories() {
            return this.filterShopCategory ? this.categories.filter(c => c.id === this.filterShopCategory) : this.categories;
        },
        filteredProducts() {
            return Product.getFiltered(this.filterShopCategory, this.filterShopPoint, this.filterShopRank, this.filterShopNew);
        },
        productsLength() {
            return this.filteredProducts.length;
        },
        untilEverythingIsLoaded() {
            return this.$wait.is(LOADER_FETCH_PRODUCTS);
        },
    },
    methods: {
        ...mapActions([
            'setFilter',
        ]),
        productsByCategory(category) {
            return Product.getByCategory(category, this.filterShopCategory, this.filterShopPoint, this.filterShopRank, this.filterShopNew);
        },
        onChangeFilter(i, v) {
            this.$vuetify.goTo('#shop-filter', {
                offset: document.querySelector('.ios-top-bar').offsetHeight,
            });
            this.setFilter({item: i, value: v});
        },
    },
    mounted() {
        if (this.tours && !this.tourShop) {
            this.$tours['shopTour'].start();
        }
        // Product.fetch();
    },
    beforeDestroy() {
        if (this.$tours['shopTour'] && this.$tours['shopTour'].isRunning) {
            this.$tours['shopTour'].stop();
        }
    },
};
</script>
